import routes from './routes'

export const slug = 'flight-dashboard'
export { routes }
